// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gapsy-download-dropdown_dropdownWrapper__rqUDe {
  position: relative;
  display: inline-block;
  width: fit-content;
}

.gapsy-download-dropdown_container__z\\+o0s {
  display: inline-block;
  height: auto;
}

.gapsy-download-dropdown_dropdownMenu__7ejYN {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1050; /* Bootstrap z-index context */
  background-color: #fff;
  border: 1px solid #ccc;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-radius: 6px;
  min-width: 160px;
  padding: 4px 0;
}

.gapsy-download-dropdown_dropdownItem__5Rzpc {
  background: none;
  border: none;
  width: 100%;
  text-align: left;
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
  color: #333;
  list-style: none;
}

.gapsy-download-dropdown_dropdownItem__5Rzpc:hover {
  background-color: #f0f0f0;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/gapsy-download-dropdown.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,aAAa,EAAE,8BAA8B;EAC7C,sBAAsB;EACtB,sBAAsB;EACtB,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".dropdownWrapper {\r\n  position: relative;\r\n  display: inline-block;\r\n  width: fit-content;\r\n}\r\n\r\n.container {\r\n  display: inline-block;\r\n  height: auto;\r\n}\r\n\r\n.dropdownMenu {\r\n  position: absolute;\r\n  top: 100%;\r\n  left: 0;\r\n  z-index: 1050; /* Bootstrap z-index context */\r\n  background-color: #fff;\r\n  border: 1px solid #ccc;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n  border-radius: 6px;\r\n  min-width: 160px;\r\n  padding: 4px 0;\r\n}\r\n\r\n.dropdownItem {\r\n  background: none;\r\n  border: none;\r\n  width: 100%;\r\n  text-align: left;\r\n  padding: 8px 16px;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n  color: #333;\r\n  list-style: none;\r\n}\r\n\r\n.dropdownItem:hover {\r\n  background-color: #f0f0f0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdownWrapper": `gapsy-download-dropdown_dropdownWrapper__rqUDe`,
	"container": `gapsy-download-dropdown_container__z+o0s`,
	"dropdownMenu": `gapsy-download-dropdown_dropdownMenu__7ejYN`,
	"dropdownItem": `gapsy-download-dropdown_dropdownItem__5Rzpc`
};
export default ___CSS_LOADER_EXPORT___;
